import { StepProps, useMutation } from '@betterment/js-runtime';
import { Button, CenteredWorkflowLayout, ErrorText, Flex, Label } from '@betterment/style-closet-react';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';

import { RequestValues } from './Controller';

import Footer from '../Shared/components/Footer';
import { PhoneNumberSchema } from '../Shared/phone-number-schema';
import { urlBuilder } from '../Shared/urlBuilder';
import { FormikMaskedInput } from '../SignupFlow/components/PhoneNumber';
import { convertApiErrorsToFormikMsg, overridePhoneNumberErrorMessage } from '../SignupFlow/form-helpers';

const StepSchema = Yup.object<Partial<RequestValues>>().shape({
  phoneNumber: PhoneNumberSchema,
});

const JointAccountInvitationProspectSecondaryPhone: React.FC<React.PropsWithChildren<StepProps<RequestValues>>> = ({
  goToNextStep,
  flowState,
}) => {
  const name = flowState.values?.firstName ? `${flowState.values.firstName}'s` : 'your';

  const [validatePhoneNumber] = useMutation(urlBuilder.apiV2ValidatePhoneNumber.absolute());
  const validate = async ({ phoneNumber }: Partial<RequestValues>) => {
    const { errors } = await validatePhoneNumber({ phoneNumber });
    if (errors) {
      return convertApiErrorsToFormikMsg(errors, { overrideErrorMessage: overridePhoneNumberErrorMessage });
    }
    return {};
  };

  const onSubmit = (values: RequestValues) => {
    goToNextStep({ phoneNumber: values.phoneNumber });
  };

  return (
    <CenteredWorkflowLayout title="Joint Checking signup" heading={`What is ${name} phone number?`}>
      <CenteredWorkflowLayout.Slot name="content">
        <Formik
          onSubmit={onSubmit}
          validate={validate}
          validationSchema={StepSchema}
          initialValues={flowState.values}
          validateOnChange={false}
        >
          <Form>
            <Flex.Item flex="0 0 200px">
              <Label htmlFor="phoneNumber" fontSize={1}>
                Phone number
              </Label>
              <FormikMaskedInput name="phoneNumber" id="phoneNumber" type="tel" variant="phone" autoFocus={true} />
              <ErrorMessage name="phoneNumber" component={ErrorText} />
            </Flex.Item>
            <CenteredWorkflowLayout.Actions>
              <Button type="submit" px="8">
                Continue
              </Button>
            </CenteredWorkflowLayout.Actions>
          </Form>
        </Formik>
      </CenteredWorkflowLayout.Slot>
      <CenteredWorkflowLayout.Slot name="footer">
        <Footer />
      </CenteredWorkflowLayout.Slot>
    </CenteredWorkflowLayout>
  );
};

export default JointAccountInvitationProspectSecondaryPhone;
